let visitToken = 0;
let claimedToken = -1;

export function startCentinelaVisit() {
  visitToken += 1;
}

export function claimCentinelaBoot() {
  if (claimedToken === visitToken) return false;
  claimedToken = visitToken;
  return true;
}
